/**
 * Shell Ready
 * --------------------
 * Handles the readiness of the shell (main app initialization).
 *
 * @author  Harvinder Singh <harvinder@maropost.com>
 * @created 2025-09-12
 */

/**
 * A Promise that represents the "readiness" of the shell (main app initialization).
 * microfrontends can await this promise
 * to ensure that all necessary app setup (auth, accounts, feature flags, etc.) is complete
 * before loading any microfrontends.
 */
let resolveFn: () => void
export const shellReady = new Promise<void>((resolve) => {
  resolveFn = resolve
})

/**
 * Marks the shell as ready.
 * This resolves the `shellReady` promise,
 * allowing microfrontends to continue execution safely.
 */
export function markShellReady() {
  resolveFn()
}
